import { isEqual } from "lodash";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";

import {
  editFormDataAF,
  editFormDataInitialSnapshotAF,
  hasKeys,
  hookFormContextAF,
  IRideDto,
  RideCrudModeKey,
  RideCrudModeKeyTuple,
} from "@ryde/shared";

export const useRideUpdateFieldsChanges = () => {
  // used dirtyFields, for fields in form context
  const rideFormContext = useRecoilValue(
    hookFormContextAF(RideCrudModeKey.uiUnit),
  );

  // used for compare fields without dirtyFields like passengerInfo, stationsInfo, etc.
  const currentRide = useRecoilValue<Partial<IRideDto> | undefined>(
    editFormDataAF(RideCrudModeKeyTuple),
  );
  // used for compare fields without dirtyFields like passengerInfo, stationsInfo, etc.
  const initialRideSnapshotDto = useRecoilValue<IRideDto | undefined>(
    editFormDataInitialSnapshotAF(RideCrudModeKeyTuple),
  );

  const dirtyFields = rideFormContext?.dirtyFields;
  const initialMetadata = initialRideSnapshotDto?.metadata ?? {};
  const currentMetadata = currentRide?.metadata ?? {};

  const isDataComputedHasChanged = useMemo(() => {
    return (
      !isEqual(initialMetadata.stationsInfo, currentMetadata.stationsInfo) ||
      !isEqual(initialMetadata.passengersInfo, currentMetadata.passengersInfo)
    );
  }, [
    currentMetadata.passengersInfo,
    currentMetadata.stationsInfo,
    initialMetadata.passengersInfo,
    initialMetadata.stationsInfo,
  ]);

  const isRideFieldsChanged = isDataComputedHasChanged || hasKeys(dirtyFields);

  return { isRideFieldsChanged };
};
